"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  STANDARD: 'standard',
  BUTTON_COUNT: 'button_count',
  BUTTON: 'button',
  BOX_COUNT: 'box_count'
};
exports.default = _default;
//# sourceMappingURL=LikeLayout.js.map